<template>
  <div class="room remote-history" v-loading="loading" ref="room">
    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    <div class="table-command">
      <span class="table-command-item-key">设备组:</span>
      <el-select class="table-command-select" v-model="stationName" placeholder="请选择设备组" clearable>
        <el-option v-for="item in stationNameList" :key="item" :label="item" :value="item"></el-option>
      </el-select>
      <span class="table-command-item-key">查询天数:</span>
      <el-select class="table-command-select" v-model="queryDays" placeholder="请选择查询天数" clearable>
        <el-option v-for="item in queryDaysList" :key="item" :label="item" :value="item"></el-option>
      </el-select>
      <span class="table-command-item-key">报告时间: {{ bridgeData.startDate + " - " + bridgeData.endDate }}</span>

      <!--右侧-->
      <el-tag class="percentage-tag dh-right" effect="dark" :type="bridgeData.scoreTagType">{{ bridgeData.score }}</el-tag>
      <span class="table-command-item-key dh-right">桥梁综合分数: </span>
      <span class="table-command-item-key dh-right">桥梁名称: {{ bridgeData.bridgeName }}</span>
    </div>
    <el-table :data="tableData" style="width: 100%" :max-height="tableMaxHeight">
      <el-table-column align="center" label="序号" prop="index" width="80"></el-table-column>
      <el-table-column align="center" label="设备名称" prop="deviceName" width="150"></el-table-column>
      <el-table-column align="center" label="设备组名称" prop="stationName"></el-table-column>
      <el-table-column align="center" label="取得分" prop="ActualScore"></el-table-column>
      <el-table-column align="center" label="总分数" prop="ExpectedScore"></el-table-column>
      <el-table-column align="center" label="最终分数">
        <template slot-scope="scope">
          <el-tag class="percentage-tag" effect="dark" :type="scope.row.scoreTagType">{{ scope.row.score }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <el-button size="small" type="primary" @click="displayScoreDetail(scope.row.deviceId)" class="table-button">分数详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      :style="pageStyle"
      layout="prev, pager, next"
      :total="totalCount"
      :page-size="pageSize"
      @current-change="currentChange"
      ref="page"
    ></el-pagination>
    <!--计分详情-->
    <el-dialog width="1200px" title="设备计分详情" :visible.sync="scoreDetailDialogVisible">
      <div
        class="el-table el-table--fit el-table--border el-table--scrollable-y el-table--enable-row-hover el-table--enable-row-transition"
        style="width: 100%; height: 450px"
      >
        <div class="el-table__header-wrapper">
          <table cellspacing="0" cellpadding="0" border="0" class="el-table__header" style="width: 100%">
            <!-- <colgroup>
              <col width="450">
              <col width="360">
            </colgroup>-->
            <thead class>
              <tr class="el-table-header__row">
                <th class="is-leaf">设备名</th>
                <th class="is-leaf">设备组</th>
                <th class="is-leaf">计分项目</th>
                <th class="is-leaf">分数</th>
              </tr>
            </thead>
          </table>
        </div>
        <div class="el-table__body-wrapper is-scrolling-none" style="height: 401px">
          <table cellspacing="0" cellpadding="0" border="0" class="el-table__body" style="width: 100%">
            <!-- <colgroup>
              <col width="450">
              <col width="360">
            </colgroup>-->
            <tbody>
              <tr class="el-table__row dialog-table-row" v-for="(value, key, index) in scoreDetailDialogDevice.PenaltyList" :key="index">
                <td>{{ scoreDetailDialogDevice.deviceName }}</td>
                <td>{{ scoreDetailDialogDevice.stationName }}</td>
                <td>{{ key }}</td>
                <td v-if="value === null || value === undefined">不适用</td>
                <td v-else>{{ value }}</td>
              </tr>
              <tr class="el-table__row dialog-table-row">
                <td>{{ scoreDetailDialogDevice.deviceName }}</td>
                <td>{{ scoreDetailDialogDevice.stationName }}</td>
                <td>取得分/总分数</td>
                <td>{{ scoreDetailDialogDevice.scoreDetail }}</td>
              </tr>
              <tr class="el-table__row dialog-table-row">
                <td>{{ scoreDetailDialogDevice.deviceName }}</td>
                <td>{{ scoreDetailDialogDevice.stationName }}</td>
                <td>最终分数</td>
                <td>{{ scoreDetailDialogDevice.score }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="scoreDetailDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
  <script>
import { mapGetters } from "vuex";

export default {
  name: "RemoteHistory",
  data() {
    return {
      timer: null,
      tableData: [],
      fullData: [],
      filterData: [],
      loading: true,
      shownewUser: false,
      scoreDetailDialogVisible: false,
      scoreDetailDialogDevice: {},
      stationNameList: [],
      queryDaysList: [1, 3, 5, 7, 15],
      queryDays: 1,
      checkUserId: "",
      totalCount: 0,
      currentPage: 1,
      pageSize: 20,
      bridgeId: "",
      stationName: "不使用",
      bridgeTranslateDict: {},
      deviceTranslateDict: {},
      deviceNameReplaceList: ["状态", "(枚举)"],
      tableMaxHeight: 777,
      clientHeight: 0,
      pageStyle: {},
      paginationHeight: 70,
      firstIndex: 0,
      lastIndex: 0,
    };
  },
  computed: {
    ...mapGetters({
      isAdmin: "getIsAdmin",
      bridgeList: "getBridgeList",
    }),
  },
  mounted() {
    this.loading = true;

    if (this.$route.query.bridgeId) {
      let validBridgeId = false;
      for (let bridge of this.bridgeList) {
        if (bridge.id === this.$route.query.bridgeId) {
          validBridgeId = true;
          break;
        }
      }

      if (validBridgeId) {
        this.bridgeId = this.$route.query.bridgeId;
      }
    }

    this.getDataList();

    window.onresize = () => {
      this.clientHeight = document.documentElement.clientHeight;
    };
    this.tableMaxHeight = this.$refs.room.offsetHeight - this.paginationHeight;
    this.pageStyle = {
      left: (this.$refs.room.clientWidth - this.$refs.page.$el.clientWidth) / 2 + "px",
    };

    this.timer = setInterval(() => {
      this.getDataList();
    }, this.REFRESH_SECOND);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  watch: {
    clientHeight(newVal, oldVal) {
      this.tableMaxHeight = this.$refs.room.offsetHeight - this.paginationHeight;
    },
    totalCount() {
      this.$nextTick().then(() => {
        this.pageStyle = {
          left: (this.$refs.room.clientWidth - this.$refs.page.$el.clientWidth) / 2 + "px",
        };
      });
    },
    bridgeId() {
      let query = JSON.parse(JSON.stringify(this.$route.query));
      query.bridgeId = this.bridgeId;
      this.$router.replace({ query: query });

      this.refreshData();
    },
    stationName(){
      this.currentPage = 1;
      this.applyPageFilter();
      this.getPageData();
    },
    queryDays(){
      this.currentPage = 1;
      this.loading = true;
      this.getDataList();
    },
  },
  methods: {
    refreshData() {
      this.loading = true;
      this.getDataList();
    },
    currentChange(index) {
      this.loading = true;
      this.currentPage = index;
      this.getPageData();
    },
    getDataList() {
      this.$http.get("/socketCommStatus/GetSocketCommHistoryReport?bridgeId=" + this.bridgeId + "&queryDays=" + this.queryDays).then((res) => {
        let resData = res.data;

        let bridgeData = {
          startDate: resData.startDateStatistics,
          endDate: resData.endDateStatistics,
          score: resData.FinalScore,
          bridgeName: resData.bridgeName,
        };
        if (bridgeData.score > 90) {
          bridgeData.scoreTagType = "success";
        } else if (bridgeData.score > 50) {
          bridgeData.scoreTagType = "warning";
        } else {
          bridgeData.scoreTagType = "danger";
        }
        this.bridgeData = bridgeData;

        let stationNameList = ["不使用"];
        let stationNameStationDataDict = {};
        for (let stationData of resData.stationCommHistoryList) {
          stationNameList.push(stationData.stationName);
          let stationDictItem = {
            stationName: stationData.stationName,
            score: stationData.FinalScore,
          };
          stationNameStationDataDict[stationData.stationName] = stationDictItem;
        }
        this.stationNameList = stationNameList;
        this.stationNameStationDataDict = stationNameStationDataDict;
        this.stationName = "不使用";

        let deviceDataList = [];
        let deviceIdDeviceDict = {};
        for (let deviceData of resData.deviceCommHistoryList) {
          deviceData.score = deviceData.FinalScore;
          deviceDataList.push(deviceData);
          deviceIdDeviceDict[deviceData.deviceId] = deviceData;

          if (deviceData.score > 90) {
            deviceData.scoreTagType = "success";
          } else if (deviceData.score > 50) {
            deviceData.scoreTagType = "warning";
          } else {
            deviceData.scoreTagType = "danger";
          }

          deviceData.scoreDetail = deviceData.ActualScore + " / " + deviceData.ExpectedScore;
        }

        this.deviceIdDeviceDict = deviceIdDeviceDict;
        this.fullData = deviceDataList;
        this.applyPageFilter();
        this.getPageData();
      });
    },
    applyPageFilter() {
      let result = [];
      if (!this.stationName || this.stationName === "NA" || this.stationName === "" || this.stationName === "不使用") {
        let index = 0;
        for (let item of this.fullData) {
          index++;
          item.index = index;
          result.push(item);
        }

        this.filterData = result;
        this.totalCount = result.length;
      } else {
        let index = 0;
        for (let item of this.fullData) {
          if (item.stationName !== this.stationName) {
            continue;
          }

          index++;
          item.index = index;
          result.push(item);
        }

        this.filterData = result;
        this.totalCount = result.length;
      }
    },
    getPageData() {
      let startIndex = (this.currentPage - 1) * this.pageSize;
      let endIndex = this.currentPage * this.pageSize - 1;

      let dataList = [];
      for (let i = startIndex; i <= endIndex; i++) {
        if (i >= this.filterData.length) {
          break;
        }

        dataList.push(this.filterData[i]);
      }

      this.tableData = dataList;
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },
    displayScoreDetail(deviceId) {
      if (!deviceId || deviceId === "" || !this.deviceIdDeviceDict[deviceId]) {
        this.$message({
          message: "无效的目标设备. " + deviceId,
          type: "warning",
        });
        return;
      }

      let device = this.deviceIdDeviceDict[deviceId];
      this.scoreDetailDialogDevice = device;
      this.scoreDetailDialogVisible = true;
    },
    hrefToDetailPage(bridgeId) {
      this.$router.push("/admin/socketCommStatusDetail?bridgeId=" + bridgeId);
    },
    translateBridgeName(bridgeId) {
      for (let bridge of this.bridgeList) {
        if (bridge.id === bridgeId) {
          return bridge.name;
        }
      }
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.remote-history {
  margin-top: 20px;
  background-color: #fff;
  padding: 20px;
  // height: 784px !important;
  height: calc(100% - 50px) !important;
  position: relative;
  .table-command {
    // display: flex;
    // justify-content: flex-end;
    margin-bottom: 20px;
  }
  .table-command-item-key {
    margin-right: 10px;
    margin-left: 20px;
    margin-top: 10px;
  }
  .table-command-input {
    width: 150px;
  }
  .table-command-select {
    width: 150px;
  }
  .pagination {
    position: absolute;
    bottom: 0;
  }
}
.status-tag {
  cursor: pointer;
}
.table-button {
  margin-bottom: 10px;
  margin-left: 10px;
}
.percentage-tag {
  min-width: 75px;
}

::v-deep .el-pagination {
  text-align: center;
}

.el-table th,
.el-table td {
  text-align: center;
}
.dialog-table-row {
  height: 60px;
}
.percentage-tag {
  min-width: 75px;
}
.dh-right {
  float: right;
}
</style>
  